import React from 'react';
import PropTypes from 'prop-types';
import { BiCopy } from 'react-icons/bi';
import { toastSuccess } from 'react-geek-toast';

function CopyToClipboard({ value, copyValue }) {
  const handleCopyToClipboard = (e) => {
    e.preventDefault();
    const toCopy = copyValue || value;
    navigator.clipboard.writeText(toCopy);
    toastSuccess('Copied to clipboard!');
  };
  return (
    <a
      className="flex space-x-1 text-black hover:underline"
      href="/"
      onClick={handleCopyToClipboard}
    >
      <span>{value}</span>
      <BiCopy />
    </a>
  );
}

CopyToClipboard.defaultProps = {
  copyValue: '',
};

CopyToClipboard.propTypes = {
  value: PropTypes.string.isRequired,
  copyValue: PropTypes.string,
};

export default CopyToClipboard;
